import { z } from "zod";
import { zStringId } from "../../utils";
import { zUserSnippet } from "../users";
import { zServicePackageExtraServices } from "../services";

export const zCartItem = z.object({
  serviceDoc: z.object({
    _id: zStringId(),
    title: z.string(),
    images: z.string().array(),
    userDoc: zUserSnippet,
  }),
  packageDoc: z.object({
    _id: zStringId(),
    name: z.string(),
    description: z.string().optional(),
    requiredDays: z.number(),
    extraServices: zServicePackageExtraServices,
    price: z.number().nonnegative(),
  }),
  tax: z.number().optional(),
});

export const zCart = z.object({
  _id: zStringId().optional(),
  cartItems: zCartItem.array(),

  subTotalTaxExclusive: z.number().nonnegative(),
  serviceCharges: z.number().nonnegative(),
  totalTax: z.number().nonnegative(),
  total: z.number().nonnegative(),

  cartMinimumAmount: z.number().nonnegative(),
  servicesRemoved: z.string().array(),
  cartValid: z.boolean(),
});

export type CartItem = z.infer<typeof zCartItem>;
export type Cart = z.infer<typeof zCart>;
